import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '主页', to: '/' },
  { label: '课程分类', to: '/category' },
  { label: '专题', to: '/#topics' },
  { label: '搜索', to: '/search' },
  { label: '关于', to: '/about' },
  { label: '联系', to: '/contact' },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    if (to.startsWith('/#')) return false;
    return location.pathname.startsWith(to);
  };

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : '/search');
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl md:text-2xl">
              <i className="ri-graduation-cap-fill"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-extrabold text-lg md:text-xl text-foreground-950 tracking-tight">
                秘密教学
              </span>
              <span className="hidden sm:block text-[10px] md:text-xs text-foreground-500 font-label tracking-widest">
                SECRET TEACHING
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3.5 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive(item.to)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <form
              onSubmit={submitSearch}
              className="hidden md:flex items-center h-10 rounded-full border border-background-300 bg-background-50 pl-3.5 pr-1 min-w-[180px] lg:min-w-[220px]"
            >
              <span className="w-5 h-5 flex items-center justify-center text-foreground-400 text-base">
                <i className="ri-search-line"></i>
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索课程…"
                className="flex-1 bg-transparent border-0 outline-none px-2 text-sm text-foreground-900 placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="h-8 px-3 rounded-full bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                搜索
              </button>
            </form>

            <Link
              to="/search"
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 text-xl cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line"></i>
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 text-2xl cursor-pointer"
              aria-label="菜单"
            >
              <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 animate-fade-up">
          <nav className="flex flex-col px-4 py-3">
            <form onSubmit={submitSearch} className="flex items-center gap-2 mb-2">
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索课程…"
                className="flex-1 h-11 rounded-lg border border-background-300 bg-background-50 px-3 text-sm outline-none focus:border-primary-400"
              />
              <button
                type="submit"
                className="h-11 px-4 rounded-lg bg-primary-500 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                搜索
              </button>
            </form>
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-3 rounded-lg text-base font-medium cursor-pointer ${
                  isActive(item.to)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-800 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}